import React, { useState, useRef, useEffect } from 'react';

import {
  Upload,
  Avatar,
  Typography,
  Button,
  message,
  Input,
  Tooltip,
} from 'antd';
import { DeleteOutlined, QuestionOutlined } from '@ant-design/icons';

import withTranslations from 'app/components/HOGs/withTranslations';

// UTILITY
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

// IMAGES
import { useSelector } from 'react-redux';
import { fixHttps } from 'app/components/Utility/coreFunctions';
import { changePositionPoint } from './selectTourType';
import tourPrevAPI from '../../../../API/tour.prev.api';
import CloseButton from '../../../Utility/closeButton';
import { getPointIcon } from '../extraFuncs';
import ModalPreviewPictures from '../../../Utility/modalPreviewPicture';
import { DeleteIcon, EditIcon } from '../components/svg';
import { addToDownload } from '../../../Utility/utility';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';

const { Paragraph } = Typography;
const { Dragger } = Upload;

const deletePoint = ({ id, isEmpty = false }) => {
  if (isEmpty) {
    publish(way.DRIVE_LIST_REMOVE_EMPTY_VIA_POINT, { customId: id });
  } else {
    publish(way.DRIVE_MAP_POINT_REMOVE, { customId: id });
  }
};

const updatePointMedia = (pointId, images) => {
  publish(way.DRIVE_PREVIEW_POINT_UPDATE, { id: pointId, images });
};

const addNewPointPicture = (file, tourData, dataPoint) => {
  return tourData.points.map((item) => {
    if (item.id === dataPoint?.id) {
      item.images.unshift(file);
      updatePointMedia(dataPoint?.id, item.images);
    }
    return item;
  });
};
const deletePointPictures = (file, tourData, dataPoint) => {
  return tourData.points.map((item) => {
    if (item.id === dataPoint?.id) {
      item.images.splice(item.images.indexOf(file), 1);
      updatePointMedia(dataPoint?.id, item.images);
    }
    return item;
  });
};
export const getDescription = () => 'DESCRIPTION';
export const getPointTitle = () => 'Name of point';

const Preview = (props) => {
  const { isEditMode, hasUserPermition, editChoose, closePreview, tr } = props;

  const { openModalTourDownload, TourDownloadBasketData, TourDownloadCoord } =
    useActions();

  const tourData = useSelector((store) => store.tourFullData.activeMultiPart);
  const dataPoint = useSelector((store) => store.tourFullData.dataPoint);
  const downloadTourGps = useSelector((store) => store.tourDownload);

  const [tmpTitle, setTmpTitle] = useState(dataPoint?.title);
  const [tmpDesc, setTmpDesc] = useState(dataPoint?.description);
  const [full, setFull] = useState(false);

  const timeout = useRef(null);
  const tagWidth = useRef(null);

  const emptyDesc = tr.Description;
  const emptyTitle = tr['Name of point'];
  const addPointDownload = tr['Add point to download'];
  const messageText = {
    tourAdded: tr['Already added to download'],
  };

  useEffect(() => {
    setTmpTitle(dataPoint.title);
    setTmpDesc(dataPoint.description);
  }, [dataPoint]);

  const savePointData = (title, desc) => {
    tourData.points.forEach((item) => {
      if (item.id === dataPoint?.id) {
        item.title = title;
        item.description = desc;
      }
    });
    publish(way.DRIVE_PREVIEW_POINT_UPDATE, { id: dataPoint?.id, title, desc });
  };

  const timeoutSaving = (title, desc) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      savePointData(title, desc);
    }, 0);
  };

  const changeTitle = (val) => {
    setTmpTitle(val);
    if (val) {
      timeoutSaving(val, tmpDesc);
    } else {
      timeoutSaving(dataPoint?.address, tmpDesc);
    }
  };
  const changeDesc = (val) => {
    if (val !== emptyDesc) {
      setTmpDesc(val);
      timeoutSaving(tmpTitle, val);
    } else if (val === emptyDesc) {
      timeoutSaving(tmpTitle, '');
    }
  };

  const getPrefixAddress = () => {
    if (isEditMode) {
      return changePositionPoint(dataPoint, tourData.points);
    }
    return <div className="pointType">{getPointIcon(dataPoint, false)}</div>;
  };

  const dragImgClass =
    dataPoint && dataPoint.images && !dataPoint?.images.length
      ? 'addImage'
      : 'addImage nextImage';

  const getImage = () => {
    if (dataPoint?.images && dataPoint?.images[0] && dataPoint?.images.length) {
      return (
        <>
          <img
            src={
              dataPoint?.images[0].fullpath
                ? fixHttps(dataPoint?.images[0].fullpath)
                : fixHttps(dataPoint?.images[0].thumbUrl)
            }
            alt="Tour main"
            onClick={() => setFull(true)}
            aria-hidden="true"
          />
          {isEditMode ? (
            <Tooltip title={tr['Delete image']}>
              <DeleteOutlined
                className="delete_icon"
                theme="filled"
                onClick={() => {
                  deletePointPictures(
                    dataPoint?.images[0],
                    tourData,
                    dataPoint
                  );
                }}
              />
            </Tooltip>
          ) : null}
        </>
      );
    }
    if (isEditMode) {
      return (
        <>
          <div className="ant-upload-drag-point-picture" />
          <div className="ant-upload-drag-point-text">
            {tr['Click or drag file to this area to upload']}
          </div>
        </>
      );
    }
    return (
      <Avatar
        shape="square"
        size={120}
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        icon={<QuestionOutlined />}
      />
    );
  };

  return Object.keys(dataPoint).length === 0 ? null : (
    <>
      <div className="viaPreviewLayout">
        <div className="viaPreviewContainer">
          <div
            style={{
              position: 'absolute',
              right: -5,
              top: -5,
              cursor: 'pointer',
              width: 20,
              height: 20,
              zIndex: 5,
            }}
            onClick={closePreview}
            aria-hidden="true"
          >
            <CloseButton />
          </div>

          <div className="viaPreviewContent">
            <div className="imgBig">
              <div className="mainImg">{getImage()}</div>
              {isEditMode ? (
                <div
                  className={dragImgClass}
                  onClickCapture={(event) => {
                    if (
                      dataPoint?.images &&
                      dataPoint?.images.length > 0 &&
                      event.target.className &&
                      event.target.className !== 'ant-upload-drag-picture'
                    ) {
                      event.stopPropagation();
                      event.preventDefault();
                      setFull(true);
                    }
                  }}
                >
                  <Dragger
                    name="file"
                    listType="picture-card"
                    multiple
                    showUploadList={{
                      showPreviewIcon: false,
                      showRemoveIcon: true,
                    }}
                    action={tourPrevAPI.getUploadPictureURL()}
                    onChange={(info) => {
                      const { file } = info;
                      const { status } = info.file;
                      if (status === 'done') {
                        const img = file.response.body;
                        addNewPointPicture(img, tourData, dataPoint);
                        message.success(
                          `${info.file.name} file uploaded successfully.`
                        );
                      } else if (status === 'error') {
                        message.error(`${info.file.name} file upload failed.`);
                      }
                    }}
                  >
                    <div className="ant-upload-drag-picture" />
                  </Dragger>
                </div>
              ) : null}
              <div
                className="secondaryImage"
                style={{
                  display:
                    dataPoint?.images && dataPoint?.images.length > 1
                      ? 'flex'
                      : 'none',
                  left: isEditMode ? 65 : 15,
                }}
              >
                <div className="first">
                  {dataPoint?.images && dataPoint?.images.length > 1 ? (
                    <img
                      src={
                        dataPoint?.images[1].fullpath
                          ? fixHttps(dataPoint?.images[1].fullpath)
                          : fixHttps(dataPoint?.images[1].thumbUrl)
                      }
                      alt="First tour"
                      onClick={() => setFull(true)}
                      aria-hidden
                    />
                  ) : null}
                </div>
                <div
                  className="second"
                  style={{
                    display:
                      dataPoint?.images && dataPoint?.images.length > 2
                        ? 'flex'
                        : 'none',
                  }}
                >
                  {dataPoint?.images && dataPoint?.images.length > 2 ? (
                    <img
                      src={
                        dataPoint?.images[2].fullpath
                          ? fixHttps(dataPoint?.images[2].fullpath)
                          : fixHttps(dataPoint?.images[2].thumbUrl)
                      }
                      alt="Tour second"
                      onClick={() => setFull(true)}
                      aria-hidden
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <div className="info">
              <div className="titlePoint">
                {isEditMode ? (
                  <Tooltip title={emptyTitle}>
                    <Input
                      onChange={(e) => changeTitle(e.target.value)}
                      onDoubleClick={() => editChoose(true)}
                      rows={1}
                      placeholder={emptyTitle}
                      defaultValue={
                        tmpTitle === dataPoint?.address ||
                        tmpTitle === emptyTitle
                          ? ''
                          : tmpTitle
                      }
                      value={tmpTitle}
                    />
                  </Tooltip>
                ) : (
                  <div>
                    {tagWidth.current && tagWidth.current.offsetWidth > 410 ? (
                      <Tooltip title={tmpTitle || emptyTitle}>
                        <span ref={tagWidth} onDoubleClick={() => editChoose()}>
                          {tmpTitle || emptyTitle}
                        </span>
                      </Tooltip>
                    ) : (
                      <span ref={tagWidth} onDoubleClick={() => editChoose()}>
                        {tmpTitle || emptyTitle}
                      </span>
                    )}
                  </div>
                )}
                {getPrefixAddress()}
              </div>

              <div className="addressPoint">
                <div>
                  {tagWidth.current && tagWidth.current.offsetWidth > 410 ? (
                    <Tooltip
                      title={dataPoint?.address ? dataPoint?.address : ''}
                    >
                      <span ref={tagWidth}>{dataPoint?.address}</span>
                    </Tooltip>
                  ) : (
                    <span ref={tagWidth}>{dataPoint?.address}</span>
                  )}
                </div>
              </div>
              <div className="descriptionPoint">
                {!isEditMode ? (
                  <Paragraph
                    editable={false}
                    onDoubleClick={() => editChoose(true)}
                  >
                    {tmpDesc || emptyDesc}
                  </Paragraph>
                ) : (
                  <Input.TextArea
                    placeholder={emptyDesc}
                    onChange={(e) => changeDesc(e.target.value)}
                    defaultValue={tmpDesc}
                    value={tmpDesc}
                  />
                )}
              </div>
              <div className="actionsBtn">
                <Tooltip title={`${dataPoint?.lat}, ${dataPoint?.lng}`}>
                  <Button
                    style={{ color: '#333' }}
                    onClick={(e) => {
                      addToDownload(
                        e,
                        downloadTourGps.data,
                        dataPoint,
                        openModalTourDownload,
                        TourDownloadBasketData,
                        TourDownloadCoord,
                        messageText,
                        'tourpoint'
                      );
                    }}
                  >
                    {addPointDownload}
                  </Button>
                </Tooltip>
              </div>
            </div>

            {hasUserPermition && !isEditMode ? (
              <div
                className="editIconPointView"
                onClick={() => editChoose()}
                aria-hidden="true"
              >
                <Tooltip title={tr['Edit this point']}>
                  <EditIcon />
                </Tooltip>
              </div>
            ) : null}
            {isEditMode ? (
              <div
                className="deleteImgPointView"
                onClick={() => deletePoint(dataPoint)}
                aria-hidden="true"
              >
                <Tooltip title={tr['Delete this point']}>
                  <DeleteIcon />
                </Tooltip>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <ModalPreviewPictures
        visible={full}
        setVisible={setFull}
        picture=""
        picturesData={dataPoint?.images}
        index={0}
      />
    </>
  );
};

export default withTranslations(Preview);
